import { render, staticRenderFns } from "./MiniArea.vue?vue&type=template&id=e07a9f08&scoped=true&"
import script from "./MiniArea.vue?vue&type=script&lang=js&"
export * from "./MiniArea.vue?vue&type=script&lang=js&"
import style0 from "./MiniArea.vue?vue&type=style&index=0&id=e07a9f08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07a9f08",
  null
  
)

export default component.exports